const A: React.FC<{ href?: string }> = ({ href }) => (
  <a href={href} className='w-8 py-2'>
    <svg
      className='mx-auto'
      width='9'
      height='13'
      viewBox='0 0 9 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.49293 7.14218L2.85055 12.2406C2.46057 12.593 1.82995 12.593 1.44411 12.2406L0.506478 11.3896C0.116491 11.0372 0.116491 10.4674 0.506478 10.1188L4.50593 6.50488L0.50233 2.89476C0.112342 2.54237 0.112342 1.97255 0.50233 1.62391L1.43996 0.769175C1.82995 0.416785 2.46057 0.416785 2.8464 0.769175L8.48878 5.86758C8.87877 6.21622 8.87877 6.78979 8.49293 7.14218Z'
        fill='#4D5F69'
      />
    </svg>
  </a>
);

export const Next: React.FC<{
  currentPageNo: any; // TODO
  pageCount: any; // TODO
  postName: any; // TODO
  params: any; // TODO
}> = ({ currentPageNo, pageCount, postName, params }) => {
  if (!currentPageNo || !pageCount || !postName) {
    return null;
  }

  // If you are on the last page, dont show next link.
  if (pageCount < currentPageNo + 1) {
    return null;
  }

  const href = `${postName}/page/${currentPageNo + 1}/${params}`;

  return <A href={href} />;
};

export default Next;
